import { createContext, useContext } from 'react';
import { CupisCoverage, type CupisCoverageData } from './CupisCoverage';
import './cupis-panel.css';

export const CupisPanelContext = createContext<{
  message: string; healthy: boolean; ages: Record<string, number | null>; frameAge: number | null; coverage?: CupisCoverageData;
} | null>(null);

export function CupisIndicator(): React.ReactElement | null {
  const data = useContext(CupisPanelContext);
  if (!data) return null;
  return <span className={`cupis-indicator${data.healthy ? '' : ' cupis-indicator--warn'}`} role="status" title={data.message}>
    <i aria-hidden="true" />{data.healthy ? 'Обновляется' : data.message}
  </span>;
}

export function CupisDiagnostics(): React.ReactElement | null {
  const data = useContext(CupisPanelContext);
  if (!data) return null;
  return <details className="cupis-diagnostics"><summary>Обновление и состав ленты</summary>
    <div className="cupis-metrics">{['live', 'prematch'].map(lane => <div key={lane}>
      <span>{lane === 'live' ? 'Лайв' : 'Прематч'}</span><b>{data.ages[lane] == null ? 'Нет ответа' : `${data.ages[lane]} с назад`}</b>
    </div>)}<div><span>Данные на экране</span><b>{data.frameAge == null ? 'Ожидаем' : `${data.frameAge} с назад`}</b></div></div>
    <CupisCoverage data={data.coverage} />
  </details>;
}
